import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import TranslationES from '../../Locales/es-co.json';
import TranslationEN from '../../Locales/en-us.json';

i18next
    .use(initReactI18next)    
    .init({
        fallbackLng:"es",        
        resources:{
            es:{
                translation:TranslationES
            },
            en:{
                translation:TranslationEN
            }
        }
    });